import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import URLSearchParams from 'url-search-params'

import { submitStripePayment } from 'modules/payments/stripe'

const mapStateToProps = state => ({
  payment: state.payments.stripe.index.payment
})

const mapDispatchToProps = dispatch => bindActionCreators({ submitStripePayment }, dispatch)

const withStripe = WrappedComponent => {
  return connect(mapStateToProps, mapDispatchToProps)(
    class Ref extends Component {
      componentDidMount() {
        const { submitStripePayment, payment } = this.props
        const source = new URLSearchParams(window.location.search).get('source')
        if (!source) return
        submitStripePayment({
          ...payment,
          source
        }).catch(() => {})
      }

      render() {
        return <WrappedComponent {...this.props} />
      }
    }
  )
}

export default withStripe



// WEBPACK FOOTER //
// ./src/containers/hocs/stripe.js